import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/steps.css"; // IMPORTANT

export default function StepNavigation({
  onBack,
  onNext,
  nextDisabled = false,
  nextLabel
}) {

const { t } = useTranslation();

  return (
    <div className="step-actions">
      {onBack && (
        <button className="step-btn" onClick={onBack}>
          {t("common.back")}
        </button>
      )}

      {onNext && (
        <button className="step-btn primary" onClick={onNext} disabled={nextDisabled}>
          {nextLabel || t("common.next")}
        </button>
      )}
    </div>
  );
}

